// extracted by mini-css-extract-plugin
module.exports = {"social":"social-module--social--24NFb"};